import React, { Component } from 'react';
import './style.sass';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import ParametersInfo from './parameters-info';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

class Parameters extends Component {
    render() {
        return (
            <FullWrapper caseName="parameters" smallPaddings={true}>
                <div className="parameters-header">
                    По данным конкурентам собираем сравнительную таблицу по определенным параметрам:
                </div>
                <ScrollAnimation animateIn="fadeInUp" offset={100} animateOnce={true} duration={1}>
                    <div className="parameters-main">
                        <div className="parameters-main__blocks">
                            <div className="parameters-main__block">
                                <span className="parameters-main__number">1.</span>Возраст сайта
                            </div>
                            <div className="parameters-main__block">
                                <span className="parameters-main__number">2.</span>{' '}
                                <div>
                                    PageSpeed Insights <span>Мобильная версия (посадочные)</span>
                                </div>
                            </div>
                            <div className="parameters-main__block">
                                <span className="parameters-main__number">3.</span>{' '}
                                <div>
                                    PageSpeed Insights <span>Десктопная версия (посадочные)</span>
                                </div>
                            </div>
                            <div className="parameters-main__block">
                                <span className="parameters-main__number">4.</span>Видимость в
                                Яндекса (%)
                            </div>
                        </div>

                        <div className="parameters-main__blocks">
                            <div className="parameters-main__block">
                                <span className="parameters-main__number">5.</span>Видимость в
                                Google (%)
                            </div>
                            <div className="parameters-main__block">
                                <span className="parameters-main__number">6.</span>Региональные
                                поддомены/Подпапки
                            </div>
                            <div className="parameters-main__block">
                                <span className="parameters-main__number">7.</span>Количество
                                страниц в индексе (Яндекс)
                            </div>
                            <div className="parameters-main__block">
                                <span className="parameters-main__number">8.</span>Количество
                                страниц в индексе (Google)
                            </div>
                        </div>

                        <div className="parameters-main__blocks">
                            <div className="parameters-main__block">
                                <span className="parameters-main__number">9.</span>Группы запросов,
                                разбитые на отдельные страницы
                            </div>
                            <div className="parameters-main__block">
                                <span className="parameters-main__number">10.</span>Статейный
                                раздел, приносящий трафик
                            </div>
                            <div className="parameters-main__block">
                                <span className="parameters-main__number">11.</span>{' '}
                                <div>
                                    Наличие определенных блоков{' '}
                                    <span>(например FAQ, «Бонусы для клиентов»)</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </ScrollAnimation>
                <ParametersInfo />
            </FullWrapper>
        );
    }
}

export default Parameters;
